import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FaPlay } from "react-icons/fa";
import axios from "axios";
import DashboardHeader from "../../Header/DashboardHeader";
import DashboardFooter from "../../Footer/DashboardFooter";
import DashboardLeftMenu from "../../Dashboard/DashboardLeftMenu";
import { HOST_URL, NODE_HOST_URL, NODE_HOST_URL_v1 } from "../api/Api";
import Axios from "../../../axios/Axios";
import { handleUserLog } from "../../Utils/Utils";
class VoiceTemplate extends Component {
  constructor() {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;

    super();
    this.state = {
      user_id: userId,
      token: userToken,
      selectedClip: null,
      template_name: null,
      is_keypress: false,
      is_repeat: false,
      repeat_keypress: null,
      call_patch_numbers: null,
      call_patch_keypress: null,
      varibaleInTemplate: [],
      content: null,
      errorMessage: "",
      method: "create",
      successMessage: false,
      successBg: "",
      disable: false,
      language: " ",
      groupName: "",
      gender: "gender-female",
      clipGroups: [],
      clips: [],
      showPlayModal: false,
      audioUrl: "",
    };
    //this.is_keypressHandler = this.is_keypressHandler.bind(this);
  }

  remove_linebreaks(str) {
    var regex = /{#[^#]*#}/g;
    str = str.replace(regex, function (match, capture) {
      return match.replace(/[\n\r@#$%^&*{}?,.'":;()/[/]]\s*/g, "");
    });
    return str;
  }

  getVaribale() {
    var str = this.state.content;
    var regex = /{#([^#]+)#}/g;
    let m;
    var tempArr = [];
    while ((m = regex.exec(str)) !== null) {
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      tempArr.push(m[1]);
    }
    this.setState({ varibaleInTemplate: tempArr });
  }

  componentDidMount() {
    this.FatchVoiceTemplate();
    this.fetchClipGroups();
  }

  handlePlayClick = (filePath) => {
    this.setState({
      audioUrl: `https://db2.authkey.io/${filePath}`,
      showPlayModal: true,
    });
  };

  handleGroupChange = async (event) => {
    const groupName = event.target.value;
    const selectedGroup = this.state.clipGroups.find(
      (g) => g.name === groupName
    );

    if (!selectedGroup) {
      this.setState({ groupName, clips: [], selectedClip: null });
      return;
    }

    try {
      const response = await axios.post(`${NODE_HOST_URL_v1}/clipGroup`, {
        user_id: this.state.user_id,
        token: this.state.token,
        method: "fetch_tts_clip",
        clip_groupid: selectedGroup.id,
      });

      const result = response.data;

      if (result.success) {
        this.setState({
          groupName,
          clips: result.data,
          selectedClip: null,
        });
      } else {
        console.warn("Clip fetch failed:", result.message);
        this.setState({ groupName, clips: [], selectedClip: null });
      }
    } catch (error) {
      console.error("Error fetching clips:", error);
      this.setState({ groupName, clips: [], selectedClip: null });
    }
  };


  handleClipSelect = (clip) => {
    this.setState({ selectedClip: clip });
  };

  fetchClipGroups = () => {
    axios
      .post(`${NODE_HOST_URL_v1}/clipGroup`, {
        user_id: this.state.user_id,
        token: this.state.token,
        method: "fetch_ttsclip_group",
      })
      .then((response) => {
        const result = response.data;
        if (result.success) {
          // const activeGroups = result.data.filter((g) => g.status === 1);
          // this.setState({ clipGroups: activeGroups });
          this.setState({ clipGroups: response.data.data });

        } else {
          console.warn("Group fetch failed:", result.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching clip groups:", error);
      });
  };


  FatchVoiceTemplate = async () => {
    let paramData = {
      user_id: this.state.user_id,
      id: this.props.match.params.id,
      method: "retrieveid",
      token: this.state.token
    }
    let { data } = await Axios.post(`${HOST_URL}/voice_template.php`, paramData)
    if (data.success === true) {
      this.setState({
        template_name: data.data[0].template_name,
        content: data.data[0].content,
        is_active: data.data[0].is_active,
        is_flash: data.data[0].is_flash,
        is_keypress: data.data[0].is_keypress,
        is_repeat: data.data[0].is_repeat,
        language: data.data[0].tts_language,
        repeat_keypress: data.data[0].repeat_keypress,
        call_patch_numbers: data.data[0].call_patch_numbers,
        call_patch_keypress: data.data[0].call_patch_keypress,
        gender: data.data[0].tts_gender
      });
    }
  }

  CreateVoiceTemplate() {
    document.querySelector("body").scrollTo(0, 0);
    if (this.state.content === null || this.state.content === "") {
      this.setState({ successMessage: true });
      this.setState({ errorMessage: "Template Body can not be blank" });
      this.setState({ successBg: "alert alert-danger alert-dismissible" });
    } else {
      var newContent = this.remove_linebreaks(this.state.content);
      var bodyObject = {
        user_id: this.state.user_id,
        token: this.state.token,
        template_name: this.state.template_name,
        language: this.state.language,
        groupName: this.state.groupName,
        clip_name: this.state.selectedClip?.clip_name || null,
        gender: this.state.gender,
        content: newContent,
        is_keypress: this.state.is_keypress ? 1 : 0,
        is_repeat: this.state.is_repeat ? 1 : 0,
        repeat_keypress: this.state.repeat_keypress,
        call_patch_numbers: this.state.call_patch_numbers,
        call_patch_keypress: this.state.call_patch_keypress,
        method: "create",
      };

      fetch(`${HOST_URL}/voice_template.php`, {
        method: "post",
        headers: {
          "content-Type": "application/json",
        },
        body: JSON.stringify(bodyObject),
      }).then((result) => {
        result.json().then((resp) => {
          this.setState({ disable: true })
          if (resp.success === false) {
            // console.warn('message',resp.message);
            this.setState({ successMessage: true });
            this.setState({ errorMessage: resp.message });
            this.setState({
              successBg: "alert alert-danger alert-dismissible",
            });
            this.setState({ disable: false })
            handleUserLog("", "create_voice_template", "voice", resp.message, "voice_template", "", "")
          } else {
            this.setState({ successMessage: true });
            this.setState({
              successBg: "alert alert-success alert-dismissible",
            });
            this.setState({ errorMessage: resp.message });
            this.props.history.push("voice-template-list");
            this.setState({ disable: false })
            handleUserLog("", "create_voice_template", "voice", resp.message, "voice_template", "", "")
          }
        });
      });
    }
  }

  UpdateVoiceTemplate() {
    document.querySelector("body").scrollTo(0, 0);
    var newContent = this.remove_linebreaks(this.state.content);
    var bodyObject = {
      user_id: this.state.user_id,
      token: this.state.token,
      template_name: this.state.template_name,
      language: this.state.language,
      groupName: this.state.groupName,
      clip_name: this.state.selectedClip?.clip_name || "",
      gender: this.state.gender,
      content: newContent,
      id: this.props.match.params.id,
      is_keypress: this.state.is_keypress ? 1 : 0,
      is_repeat: this.state.is_repeat ? 1 : 0,
      repeat_keypress: this.state.repeat_keypress,
      call_patch_numbers: this.state.call_patch_numbers,
      call_patch_keypress: this.state.call_patch_keypress,
      method: "update",
    };

    fetch(`${HOST_URL}/voice_template.php`, {
      method: "post",
      headers: {
        "content-Type": "application/json",
      },
      body: JSON.stringify(bodyObject),
    }).then((result) => {
      result.json().then((resp) => {
        this.setState({ disable: true })
        if (resp.success === "false") {
          console.warn("message", resp.message);
          this.setState({ successMessage: true });
          this.setState({ errorMessage: resp.message });
          this.setState({ disable: false })
          handleUserLog("", "updated_voice_template", "voice", resp.message, "voice_template", "", "")
        } else {
          this.setState({ successMessage: true });
          this.setState({ successBg: "alert alert-success alert-dismissible" });
          this.setState({ errorMessage: resp.message });
          document.getElementById("voiceForm").reset();
          // window.location.reload();
          this.setState({ disable: false })
          handleUserLog("", "updated_voice_template", "voice", resp.message, "voice_template", "", "")
        }
      });
    });
  }

  handleIsKeypressChange = (e) => {
    this.setState({ is_keypress: e.target.checked });
  };


  render() {
    // console.log("is_keypress: ", this.state.is_keypress);
    return (
      <div className="wrapper">
        <DashboardLeftMenu />
        <div className="main">
          <DashboardHeader />
          <main className="content">
            <div className="container-fluid p-0">
              <div className="row mb-2 mb-xl-3">
                <div className="col-auto d-none d-sm-block">
                  <h3>
                    <strong>Create New Voice </strong> Template{" "}
                  </h3>
                </div>
              </div>
              <div className="card">
                <div className="card-body template-link">
                  <div className="row">
                    <div className="col-md-8">
                      {this.state.successMessage ? (
                        <div className={this.state.successBg} role="alert">
                          <button
                            type="button"
                            className="close"
                            data-dismiss="alert"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                          {this.state.errorMessage}
                        </div>
                      ) : null}

                      <form id="voiceForm">
                        <div className="row justify-content-center">
                          <div className="row">
                            <div className="col-12 form-group mt-2">
                              <select
                                className="form-control"
                                value={this.state.groupName}
                                onChange={this.handleGroupChange}
                                required
                              >
                                <option value="">Select Group</option>
                                {this.state.clipGroups.map((group) => (
                                  <option key={group.id} value={group.name}>
                                    {group.name}
                                  </option>
                                ))}
                              </select>
                              {/* {this.state.selectedClip && (
                                <div className="mt-2 text-muted">
                                  <small>
                                    Selected Clip: <strong>{this.state.selectedClip.clip_name}</strong>
                                  </small>
                                </div>
                              )} */}


                            </div>
                          </div>
                          {this.state.groupName && !this.state.selectedClip && (
                            <div className="row">
                              <div className="col-12">
                                <div
                                  style={{
                                    maxHeight: "100px",
                                    overflowY: "auto",
                                    border: "1px solid #ccc",
                                    borderTop: "none",
                                    borderRadius: "0 0 6px 6px",
                                  }}
                                >
                                  <table
                                    className="table mb-0"
                                    style={{ borderCollapse: "collapse" }}
                                  >
                                    <thead>
                                      <tr>
                                        <th className="col-5">Clip Name</th>
                                        <th className="col-5">File Name</th>
                                        <th className="col-2">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.clips.map((clip, index) => (
                                        <tr key={index}
                                          onClick={() => this.handleClipSelect(clip)}
                                          style={{
                                            cursor: "pointer",
                                            backgroundColor:
                                              this.state.selectedClip && this.state.selectedClip.name === clip.name
                                                ? "#e9f5ff"
                                                : "transparent",
                                          }}>
                                          <td style={{ border: "none", paddingTop: "0", paddingBottom: "3px", fontSize: "0.75rem" }}>{clip.clip_name}</td>
                                          <td style={{ border: "none", paddingTop: "0", paddingBottom: "3px", fontSize: "0.75rem" }}>{clip.filename}</td>
                                          <td style={{ border: "none", paddingTop: "0", paddingBottom: "3px", fontSize: "0.75rem" }}>
                                            {/* <button className="btn p-0 border-0 bg-transparent"
                                              style={{ color: "#0d6efd", fontSize: "0.9rem" }}
                                              title="Play">
                                              <FaPlay className="me-1" />
                                            </button> */}
                                            <button
                                              type="button" // IMPORTANT to prevent form submit
                                              className="btn p-0 border-0 bg-transparent"
                                              style={{ color: "#0d6efd", fontSize: "0.9rem" }}
                                              title="Play"
                                              onClick={(e) => {
                                                e.stopPropagation(); // Prevent row click
                                                e.preventDefault();  // Prevent any form submit behavior
                                                this.handlePlayClick(clip.file_path);
                                              }}
                                            >
                                              <FaPlay className="me-1" />
                                            </button>


                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="mb-3 col-md-12">
                            <div className="text-left">
                              <h3 className="font-weight-bold mb-4">
                                {" "}
                                Voice Template{" "}
                              </h3>
                            </div>
                            <div className="form-row">
                              <div className="form-group col-md-12">
                                <input
                                  type="text"
                                  defaultValue={this.state.template_name}
                                  onChange={(event) => {
                                    this.setState({
                                      template_name: event.target.value,
                                    });
                                  }}
                                  className="form-control"
                                  id="inputEmail4"
                                  placeholder="Enter Template Name"
                                />
                              </div>
                            </div>


                            <div className="row">
                              <div className="col-6 form-group mt-2 ">
                                <select
                                  value={this.state.language}
                                  onChange={(event) => {
                                    this.setState({ language: event.target.value });
                                  }}

                                  className="form-control"
                                >
                                  <option value="">Select Language</option>
                                  <option value="en-IN">English(India)</option>
                                  <option value="hi-IN">Hindi(India)</option>
                                  <option value="gu-IN">Gujarati(India)</option>
                                  <option value="bn-IN">Bengali(India)</option>
                                  <option value="kn-IN">Kannada (India)</option>
                                  <option value="ml-IN">Malayalam (India)</option>
                                  <option value="pa-IN">Punjabi (India)</option>
                                  <option value="ta-IN">Tamil (India)</option>
                                  <option value="te-IN">Telugu (India)</option>
                                </select>
                              </div>

                              <div className="col-6 form-group mt-2 ">
                                <select
                                  value={this.state.gender}
                                  onChange={(event) => {
                                    this.setState({ gender: event.target.value });
                                  }}
                                  className="form-control"
                                >
                                  <option value="">Select Gender</option>
                                  <option value="FEMALE">Female</option>
                                  {/* <option value="gender-male">Male</option> */}
                                </select>
                              </div>
                            </div>

                            <div className="form-group mt-2">
                              <textarea
                                defaultValue={this.state.content}
                                onChange={(event) => {
                                  this.setState({
                                    content: event.target.value,
                                  });
                                  this.getVaribale();
                                }}
                                placeholder="Template Message Example : Dear {#Name#}, Thanks for the registraion with us"
                                className="form-control"
                                rows="5"
                              ></textarea>
                            </div>
                            <div className="mt-3">
                              {/* Format */}
                              <div
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  color: "#2c2c2c",
                                  marginBottom: "8px"
                                }}
                              >
                                <strong>Format : </strong> clip1=&gt;audio,{`{#name#}`}=&gt;string,{`{#city#}`}=&gt;alpha
                              </div>

                              {/* Info */}
                              <div
                                style={{
                                  background: "#f9fafb",
                                  borderRadius: "8px",
                                  padding: "12px 14px",
                                  fontSize: "13px"
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "16px",
                                    color: "#444",
                                    lineHeight: "1.6"
                                  }}
                                >
                                  <span><strong>audio</strong> → Voice clips</span>
                                  <span><strong>string</strong> → Letters, numbers, symbols</span>
                                  <span><strong>alpha</strong> → Only letters</span>
                                </div>

                                <div
                                  style={{
                                    marginTop: "8px",
                                    fontSize: "12px",
                                    color: "#e5533d"
                                  }}
                                >
                                  ⚠ No spaces allowed (clip1=&gt;audio ✓, clip1 =&gt; audio ✗)
                                </div>
                              </div>
                            </div>
                            <div className="form-row">
                              <div className="form-group col-md-5 mt-2 ml-2">
                                <label className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={this.state.is_keypress}
                                    onChange={this.handleIsKeypressChange}
                                    value={1}
                                  />
                                  <span className="form-check-label">
                                    is keypress
                                  </span>

                                </label>
                              </div>

                              <div className="form-group col-md-5 mt-2 ml-2">
                                <label className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={this.state.is_repeat}
                                    onChange={(event) => {
                                      this.setState({
                                        is_repeat: event.target.checked,
                                      });
                                    }}
                                    value={1}
                                  />
                                  <span className="form-check-label">
                                    is Repeat
                                  </span>
                                </label>
                              </div>
                            </div>

                            <div className="form-group mt-2 ">
                              <select
                                value={this.state.repeat_keypress}
                                onChange={(event) => {
                                  this.setState({
                                    repeat_keypress: event.target.value,
                                  });
                                }}
                                className="form-control"
                              >
                                <option value="">Repeat Keypress</option>
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                              </select>
                            </div>

                            <div className="form-group mt-2 ">
                              <label>Call Patch Number</label>
                              <input
                                defaultValue={this.state.call_patch_numbers}
                                placeholder="91XXXXXXX"
                                className="form-control"
                                onChange={(event) => {
                                  this.setState({
                                    call_patch_numbers: event.target.value,
                                  });
                                }}
                                type="text"
                              />
                            </div>

                            <div className="form-group mt-2 ">
                              <select
                                value={this.state.call_patch_keypress}
                                onChange={(event) => {
                                  this.setState({
                                    call_patch_keypress: event.target.value,
                                  });
                                }}
                                className="form-control"
                              >
                                <option>Call Patch Keypress</option>
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                              </select>
                            </div>

                            {this.props.match.params.id ? (
                              <button
                                type="button"
                                onClick={() => {
                                  this.UpdateVoiceTemplate();
                                }}
                                disabled={this.state.disable ? true : false}
                                className="btn btn-sm  mt-5 btn-primary"
                              >
                                Update Template
                              </button>
                            ) : (
                              <button
                                type="button"
                                onClick={() => {
                                  this.CreateVoiceTemplate();
                                }}
                                className="btn btn-sm  mt-5 btn-primary"
                                disabled={this.state.disable ? true : false}
                              >
                                Create Template
                              </button>
                            )}
                          </div>
                        </div>
                      </form>
                    </div>

                    <div className="col-md-4">
                      <div className="card">
                        <p className="tooglebox">
                          <Link
                            className=""
                            data-toggle="collapse"
                            to="#collapseExample"
                            role="button"
                            aria-expanded="false"
                            aria-controls="collapseExample"
                          >
                            Useful Links
                          </Link>
                        </p>
                        <div className="">
                          <div className="collapse show" id="collapseExample">
                            <div className="links-set">
                              <ol className="mt-3">
                                <li>
                                  <Link to="">
                                    How to Create Voice Template
                                  </Link>
                                </li>
                                <li>
                                  <Link to="">How to Use Voice Template</Link>
                                </li>
                                <li>
                                  <Link to="">How to Use Voice Varibale </Link>
                                </li>
                                <li>
                                  <Link to="">
                                    How to Save or Choose SMS Template{" "}
                                  </Link>
                                </li>
                              </ol>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <p className="tooglebox">
                          <Link to="" className="">
                            Variables In Template
                          </Link>
                        </p>

                        <div className="card-body">
                          <form className="form-inline">
                            {this.state.varibaleInTemplate.map(
                              (item, index) => (
                                <div key={index} className="variable mr-1">
                                  <span>{item}</span>
                                </div>
                              )
                            )}
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {this.state.showPlayModal && (
                  <div
                    className="modal fade show"
                    style={{
                      display: "block",
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                    }}
                    onClick={() => this.setState({ showPlayModal: false })} // close on backdrop click
                  >
                    <div
                      className="modal-dialog modal-dialog-centered"
                      onClick={(e) => e.stopPropagation()} // prevent modal click from closing
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Audio Preview</h5>
                          <button
                            type="button"
                            style={{
                              border: "none",
                              background: "transparent",
                              fontSize: "1.5rem",
                              lineHeight: "1",
                            }}
                            onClick={() => this.setState({ showPlayModal: false })}
                          >
                            &times;
                          </button>
                        </div>
                        <div className="modal-body text-center">
                          <audio
                            controls
                            autoPlay
                            src={this.state.audioUrl}
                            style={{ width: "100%" }}
                            onError={() =>
                              alert("Unable to play audio. File path may be invalid.")
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </main>
          <DashboardFooter />
        </div>
      </div>
    );
  }
}

export default VoiceTemplate;
